import { Link } from 'react-router-dom';

export default function Footer() {
  const handleNavClick = (path: string) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-secondary-100 border-t border-secondary-200/70">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <h4 className="font-heading text-lg font-semibold text-foreground-900 mb-4">
              少妇护肤指南
            </h4>
            <p className="text-sm text-foreground-600 leading-relaxed">
              专为少妇群体打造的全方位护肤美容指南，涵盖肌肤特点分析、抗衰保湿、身材管理、产后修复等核心内容。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">
              内容分类
            </h4>
            <div className="flex flex-col gap-2">
              {[
                { path: '/category/anti-aging', label: '抗衰保湿' },
                { path: '/category/postpartum', label: '产后修复' },
                { path: '/category/body-management', label: '身材管理' },
                { path: '/category/daily-care', label: '日常护理' },
                { path: '/category/seasonal', label: '季节护肤' },
              ].map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => handleNavClick(link.path)}
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">
              热门文章
            </h4>
            <div className="flex flex-col gap-2">
              {[
                { path: '/article/shaofu-skin-characteristics', label: '少妇肌肤特点全解析' },
                { path: '/article/anti-aging-serum-guide', label: '抗衰精华液全攻略' },
                { path: '/article/postpartum-skin-recovery', label: '产后肌肤急救修复方案' },
                { path: '/article/daily-skincare-routine', label: '日常护肤全流程' },
              ].map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => handleNavClick(link.path)}
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">
              关于我们
            </h4>
            <div className="flex flex-col gap-2">
              <Link
                to="/about"
                onClick={() => handleNavClick('/about')}
                className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap"
              >
                品牌介绍
              </Link>
              <Link
                to="/about"
                onClick={() => handleNavClick('/about')}
                className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap"
              >
                联系我们
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-secondary-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 少妇护肤美容指南 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50 text-foreground-600 hover:text-primary-600 hover:bg-primary-100 transition-colors">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50 text-foreground-600 hover:text-primary-600 hover:bg-primary-100 transition-colors">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50 text-foreground-600 hover:text-primary-600 hover:bg-primary-100 transition-colors">
              <i className="ri-chat-smile-2-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}